module.exports = __webpack_public_path__ + "img/bg_level.2b14a50e.png";